var SayAsInterpretation = /* @__PURE__ */ ((SayAsInterpretation2) => {
  SayAsInterpretation2["CARDINAL"] = "cardinal";
  SayAsInterpretation2["DIGITS"] = "digits";
  SayAsInterpretation2["TELEPHONE"] = "telephone";
  SayAsInterpretation2["NAME"] = "name";
  SayAsInterpretation2["ADDRESS"] = "address";
  SayAsInterpretation2["ID"] = "id";
  SayAsInterpretation2["CHARACTERS"] = "characters";
  SayAsInterpretation2["PUNCTUATION"] = "punctuation";
  SayAsInterpretation2["DATE"] = "date";
  SayAsInterpretation2["TIME"] = "time";
  SayAsInterpretation2["CURRENCY"] = "currency";
  SayAsInterpretation2["MEASURE"] = "measure";
  return SayAsInterpretation2;
})(SayAsInterpretation || {});
((SayAsInterpretation2) => {
  function fromString(interpret) {
    switch (interpret) {
      case "cardinal":
        return "cardinal" /* CARDINAL */;
      case "digits":
        return "digits" /* DIGITS */;
      case "telephone":
        return "telephone" /* TELEPHONE */;
      case "name":
        return "name" /* NAME */;
      case "address":
        return "address" /* ADDRESS */;
      case "id":
        return "id" /* ID */;
      case "characters":
        return "characters" /* CHARACTERS */;
      case "punctuation":
        return "punctuation" /* PUNCTUATION */;
      case "date":
        return "date" /* DATE */;
      case "time":
        return "time" /* TIME */;
      case "currency":
        return "currency" /* CURRENCY */;
      case "measure":
        return "measure" /* MEASURE */;
      default:
        return void 0;
    }
  }
  SayAsInterpretation2.fromString = fromString;
})(SayAsInterpretation || (SayAsInterpretation = {}));

export { SayAsInterpretation };
//# sourceMappingURL=say-as-interpretation.enum.js.map
